/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
import CustomCard from '../../../../components/CustomCard';
import SearchSimple from '../../../../components/SearchSimples/SearchSimple';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import { Box } from '@mui/material';
import CustomTable from '../../../../components/table/CustomTable';
import { AddIcon, SubcategoriesIcon } from '../../../../components/buttons/IconButtons';
import SubCategoriesApp from '../Functionality/SubCategoriesApp';
import DeleteModal from '../../../Modals/DeleteModal';
import CreateCategory from '../Modal/CreateCategory';
import { CATEGORY_TYPE } from './../../../../pages/Dashboard/Contractors/EquipmentAndMaterial/Model/Model';
const SubCategories = () => {
    const {
        t,
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        pagination,
        contractorId,
        supplierId,
        searchElement,
        setSearchElement,
        setResults,
        option,
        rowsPerPage,
        setSearch,
        setSimpleSearch,
        setBodyForExport,
        deleteShow,
        setDeleteShow,
        selectedCategoryForDelete,
        deleteCategory,
        createSubCategoryShow,
        setCreateSubCategoryShow,
        setModified,
        viewType,
        isAllChecked
    } = SubCategoriesApp();
    return (
        <>
            <CustomCard classCard='card-border-8px overflow-hidden' classContent='p-0'>
                <div className='d-flex align-items-center m-3 mb-4'>
                    <div className='d-flex align-items-center gap-2'>
                        <Box className='icon-circle-container'>
                            <SubcategoriesIcon />
                        </Box>
                        <p className='fs-14px font-color-text-950 ibl-font-w-600'>{t('subcategory')}</p>
                    </div>

                    <ButtonAction
                        id='btn_sc_create'
                        name='create'
                        className='btn-icon-export ms-auto'
                        Icon={AddIcon}
                        onClick={() => setCreateSubCategoryShow(true)}
                    />
                </div>
                <div className='m-3'>
                    <SearchSimple
                        id={searchId}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        contractorId={contractorId}
                        supplierId={supplierId}
                        viewType={viewType}
                    />
                    <CustomTable
                        tableId={tableId}
                        searchId={searchId}
                        checkbox={false}
                        thead={thead}
                        tbody={tbody}
                        columnActions={true}
                        getActionsButtons={getActionsButtons}
                        showHeader={false}
                        isAllChecked={isAllChecked}
                    />
                    {pagination()}
                </div>
            </CustomCard>
            <DeleteModal
                show={deleteShow}
                onHide={() => setDeleteShow(false)}
                data={selectedCategoryForDelete}
                onClickFn={() => deleteCategory(selectedCategoryForDelete)}
                title_modal='delete_subcategory'
                element_modal='subcategory'
            />
            <CreateCategory
                show={createSubCategoryShow}
                onHide={() => setCreateSubCategoryShow(false)}
                titleModal='create_sub_category'
                inputModal={t('enter_subcategory_name')}
                icon={SubcategoriesIcon}
                type={CATEGORY_TYPE.SUBCATEGORY}
                setModified={setModified}
            />
        </>
    );
};

export default SubCategories;
